import { render } from "./Btn.vue?vue&type=template&id=2526fe12"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src228788682/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__